import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const ProductMonthForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Janeiro", value: 1 },
    { label: "Fevereiro", value: 2 },
    { label: "Março", value: 3 },
    { label: "Abril", value: 4 },
    { label: "Maio", value: 5 },
    { label: "Junho", value: 6 },
    { label: "Julho", value: 7 },
    { label: "Agosto", value: 8 },
    { label: "Setembro", value: 9 },
    { label: "Outubro", value: 10 },
    { label: "Novembro", value: 11 },
    { label: "Dezembro", value: 12 },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.ProductMonth}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
